import axios from "axios";

// axios.defaults.baseURL = CloudURL;

const API_URL =
  process.env.REACT_APP_ENVIRONMENT === "dev"
    ? process.env.REACT_APP_LOCAL_API_URL
    : process.env.REACT_APP_CLOUD_API_URL;

console.log("API_URL - " + API_URL);

export const APICall = axios.create({
  baseURL: API_URL,
  //   withCredentials: true, // Ensures cookies are sent with requests
  // headers: { "x-tenant-id": x_tenant_id },
  // headers: {
  //   authorization: `bearer ${token}`,
  // },
});
